"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrashCashHttpAdapter = void 0;
var lodash_1 = require("lodash");
var HttpAdapter_1 = require("./HttpAdapter");
var Registry_1 = require("./Registry");
var CrashCashHttpAdapter = /** @class */ (function (_super) {
    __extends(CrashCashHttpAdapter, _super);
    function CrashCashHttpAdapter(options) {
        return _super.call(this, options) || this;
    }
    CrashCashHttpAdapter.prototype.getEndpoint = function () {
        switch (this.options.environment) {
            case 'production':
                return 'https://games-crash-cash-registry.de-2.nsoft.cloud';
            default:
                return 'https://games-crash-cash-registry.staging.de-2.nsoft.cloud';
        }
    };
    CrashCashHttpAdapter.prototype.getEndpointPath = function () {
        // This is the URL path for the 'retail' channel.
        return "/configuration/subscriptions/".concat(this.options.productId, "/").concat(this.options.channel);
    };
    CrashCashHttpAdapter.prototype.getTranslationsEndpoint = function () {
        if (this.options.environment === 'staging') {
            return 'https://frasier.staging.de-2.nsoft.cloud/translations';
        }
        return 'https://frasier.de-2.nsoft.cloud/translations';
    };
    CrashCashHttpAdapter.prototype.getTranslationsEndpointPath = function (domain) {
        var domainId = Registry_1.registry.translationDomainsMapping[domain];
        var locale = this.options.locale && this.options.locale.split(/[-_]/)[0] || 'en';
        return "/".concat(domainId, "/locales/").concat(locale, "/tenants/").concat(this.options.tenantId, "?includeLocaleFallback=true");
    };
    CrashCashHttpAdapter.prototype.getEndpointHeaders = function () {
        return {};
    };
    CrashCashHttpAdapter.prototype.getEndpointParams = function () {
        return {};
    };
    CrashCashHttpAdapter.prototype.getTranslationsResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var channel, domains, promises, isMultipleDomain, responses, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.translationsFromFrasier)
                            return [2 /*return*/];
                        channel = this.options.applicationName === 'Retail' ? 'shop' : this.options.applicationName;
                        domains = (0, lodash_1.defaultTo)(this.options.translationDomains, [(0, lodash_1.toLower)(channel)]);
                        promises = (0, lodash_1.map)(domains, function (domain) { return __awaiter(_this, void 0, void 0, function () {
                            var url, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        url = "".concat(this.getTranslationsEndpoint()).concat(this.getTranslationsEndpointPath(domain));
                                        return [4 /*yield*/, this.httpLibrary.get(url)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.data];
                                }
                            });
                        }); });
                        isMultipleDomain = domains.length > 1;
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _a.sent();
                        if (isMultipleDomain) {
                            result = {};
                            (0, lodash_1.each)(domains, function (domain, index) {
                                result[domain] = responses[index];
                            });
                        }
                        else {
                            result = responses[0];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    CrashCashHttpAdapter.prototype.parseResponse = function (data) {
        return {
            rules: {
                maxBetNumber: { name: 'maxBetNumber', value: (0, lodash_1.defaultTo)(data.maxBetCount, 1) },
                maxBetAmount: { name: 'maxBetAmount', value: (0, lodash_1.defaultTo)(data.maxBetAmount, 100) },
                minBetAmount: { name: 'minBetAmount', value: (0, lodash_1.defaultTo)(data.minBetAmount, 1) },
                maxPossibleMultiplier: { name: 'maxPossibleMultiplier', value: (0, lodash_1.defaultTo)(data.maxPossibleMultiplier, 10000) },
            },
            productInstanceUuid: data.productInstanceId,
            translations: data.translations,
            taxes: {
                payin: {
                    policy: data.payInTax,
                },
                payout: {
                    policy: data.payoutTax,
                }
            },
            tenantName: data.tenantName,
            rawData: data,
        };
    };
    CrashCashHttpAdapter.prototype.getResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.getEndpoint()).concat(this.getEndpointPath());
                        return [4 /*yield*/, this.httpLibrary.get(url, {
                                headers: this.getEndpointHeaders(),
                                params: this.getEndpointParams(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrashCashHttpAdapter.prototype.getConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var responses, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getResponse(),
                            this.getTranslationsResponse(),
                        ])];
                    case 1:
                        responses = _a.sent();
                        data = responses[0].data;
                        data.translations = responses[1];
                        return [2 /*return*/, this.parseResponse(data)];
                }
            });
        });
    };
    return CrashCashHttpAdapter;
}(HttpAdapter_1.HttpAdapter));
exports.CrashCashHttpAdapter = CrashCashHttpAdapter;
//# sourceMappingURL=CrashCashHttpAdapter.js.map